import { format } from 'date-fns';

const DATE_FORMAT = 'yyyy-MM-dd';

/**
 * Returns the start and end dates of the current month in ISO 8601 format.
 *
 * The boundaries are formatted from their local calendar parts. Going through
 * toISOString() instead would shift them into the previous day for any timezone
 * ahead of UTC, e.g. August would start on 2026-07-31 in WAT.
 */
export function getCurrentMonthRange(): { startDate: string; endDate: string } {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();

  const startDate = format(new Date(year, month, 1), DATE_FORMAT);
  const endDate = format(new Date(year, month + 1, 0), DATE_FORMAT);

  return { startDate, endDate };
}

/**
 * Formats a date string (e.g. "2026-04-01") into a short label (e.g. "Apr 1").
 */
export function formatDateLabel(dateStr: string): string {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
